var React = require('react');

function TwitterRound (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M9.18965 7.92368L15.0422 16.0986H16.5263L10.6737 7.92368H9.18965Z","fill":"currentColor","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.8577 24.0107C19.4851 24.0107 24.8577 18.6382 24.8577 12.0107C24.8577 5.38332 19.4851 0.0107422 12.8577 0.0107422C6.23025 0.0107422 0.857666 5.38332 0.857666 12.0107C0.857666 18.6382 6.23025 24.0107 12.8577 24.0107ZM6.02368 6.2981L10.6552 12.7674L6.29406 17.7233H8.46263L11.628 14.1262L14.2032 17.7233H19.6917L14.6544 10.6872L18.5168 6.2981H16.3482L13.6815 9.32838L11.5121 6.2981H6.02368Z","fill":"currentColor","key":1})]);
}

TwitterRound.defaultProps = {"viewBox":"0 0 25 25","fill":"none"};

module.exports = TwitterRound;

TwitterRound.default = TwitterRound;
